import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
@Injectable()
export class LoaderService {
  mySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  show() {
    this.mySubject.next(true);
  }
  hide() {
    this.mySubject.next(false);
  }
}
